import React from 'react';
import { FileCode, Minimize2, Maximize2, Copy, Trash2, ChevronsDownUp, ChevronsUpDown } from 'lucide-react';
import './Toolbar.css';

const Toolbar = ({
    onFormat, onMinify, onClear, onCopy, onConvert, onEscapeChange, onFoldAll, isEscaped, isMinified = false, isFolded = false,
    convertLabel, formatLabel, minifyLabel, clearLabel, copyLabel, escapeLabel, foldAllLabel,
    showEscapeCheckbox = false, // 新增：明确控制复选框显示
    children
}) => {
    // 确保复选框显示的条件：showEscapeCheckbox 为 true 且 onEscapeChange 存在
    const shouldShowEscapeCheckbox = showEscapeCheckbox && onEscapeChange !== undefined && onEscapeChange !== null;
    
    return (
        <div className="toolbar">
            <div className="toolbar-group">
                {children}
            </div>
            <div className="toolbar-group">
                {onConvert && (
                    <button className="toolbar-btn primary" onClick={onConvert} title={convertLabel || "Convert"}>
                        <FileCode size={18} />
                        <span>{convertLabel || "Convert"}</span>
                    </button>
                )}
                <button className="toolbar-btn primary" onClick={onFormat} title={formatLabel || "Format"}>
                    <FileCode size={18} />
                    <span>{formatLabel || "Format"}</span>
                </button>
                {shouldShowEscapeCheckbox && (
                    <label className="toolbar-checkbox" title={escapeLabel || "Retain Escape Characters"}>
                        <input
                            type="checkbox"
                            checked={isEscaped ?? false}
                            onChange={(e) => onEscapeChange(e.target.checked)}
                        />
                        <span>{escapeLabel || "Retain Escape Characters"}</span>
                    </label>
                )}
                {onFoldAll && (
                    <button className="toolbar-btn" onClick={onFoldAll} title={foldAllLabel || (isFolded ? "Unfold All" : "Fold All")}>
                        {isFolded ? <ChevronsUpDown size={18} /> : <ChevronsDownUp size={18} />}
                        <span>{foldAllLabel || (isFolded ? "Unfold All" : "Fold All")}</span>
                    </button>
                )}
                {onMinify && (
                    <button className="toolbar-btn" onClick={onMinify} title={minifyLabel || (isMinified ? "Expand" : "Minify")}>
                        {isMinified ? <Maximize2 size={18} /> : <Minimize2 size={18} />}
                        <span>{minifyLabel || (isMinified ? "Expand" : "Minify")}</span>
                    </button>
                )}
            </div>
            <div className="toolbar-group">
                <button className="toolbar-btn" onClick={onCopy} title={copyLabel || "Copy"}>
                    <Copy size={18} />
                    <span>{copyLabel || "Copy"}</span>
                </button>
                <button className="toolbar-btn danger" onClick={onClear} title={clearLabel || "Clear"}>
                    <Trash2 size={18} />
                    <span>{clearLabel || "Clear"}</span>
                </button>
            </div>
        </div>
    );
};

export default Toolbar;
